import React from 'react';
import { Card } from '../Card/Card';
import { useIsMobile } from '../utils/useIsMobile';
import { Accordion, AriaHeadingLevel } from '../Accordion/Accordion';

import useStyles from './FundDetailsDialog.style';

export interface FundDetailsDialogAccordionProps {
  title: string;
  detailsClassName?: string;
}

const FundDetailsDialogAccordion: React.FC<FundDetailsDialogAccordionProps> = ({ title, children, detailsClassName }) => {
  const c = useStyles({});
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Card>
        <Accordion
          transparent
          title={title}
          detailsClassName={detailsClassName}
          titleClassName={c.accordionCardTitle}
          variant="heading"
          ariaLevel={AriaHeadingLevel.H5}
        >
          {children}
        </Accordion>
      </Card>
    );
  }

  return <Card size="equal">{children}</Card>
}

export default FundDetailsDialogAccordion;
